import { DataTableColumnDefinition, DataTableRow } from '../DataTableTypes.js';

/**
 * Given a column definition tries to introspect the value from a row using the field property or custom getter
 */
export const getValue = <TRow extends DataTableRow, TContext = unknown>(
  column: DataTableColumnDefinition<TRow, TContext>,
  row?: TRow
) => {
  let fieldValue = undefined;

  if (!row) {
    return fieldValue;
  } else if (typeof column.field === 'string') {
    fieldValue = row[column.field];
  } else if (typeof column.field === 'function') {
    fieldValue = column.field({ row, column });
  }

  return fieldValue;
};
